import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NovaSenhaComponent } from '../../layout/nova-senha/nova-senha-layout/nova-senha-layout.component';
import { NgModule } from '@angular/core';
import { EmailSenhaComponent } from '../../layout/email-senha/email-senha.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login | BUILTUP' },
  },
  {
    path: 'novaSenha',
    component: NovaSenhaComponent,
    data: { title: 'Nova Senha | BUILTUP' },
  },
  {
    path: 'esqueci-a-senha',
    component: EmailSenhaComponent,
    data: { title: 'Esqueci a senha | BUILTUP' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
